// export const API_BASE_URL: string = "http://15.207.7.226:5000/";
const location = window.location.origin.includes("localhost")
  ? "local"
  : "server";
export const API_BASE_URL: string =
  location === "local"
    ? "http://localhost:5000/"
    : "https://uat-rp.roboticodigital.com/api/";
export const WEB_URL: string = "https://uat-rp.roboticodigital.com/";
export const TABLE_ROWS_COUNT: number = 10;

export const API_PREFIX_V1 = 'api/v1/';


export const MSAL_TENANT_ID: string = '16c00da5-32e1-4bab-8472-99f12ee8b808';
export const MSAL_CLIENT_ID: string = '1ef3cae7-504a-4d75-b91e-dc993d64db78';
export const MSAL_AUTHORITY: string = `https://login.microsoftonline.com/${MSAL_TENANT_ID}`;
export const APP_VERSION: string = "129.13.10";
